import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";

var _dec, _class, _class2, _temp;

import React, { Component } from 'react';
import { locale } from "../../../lib/locale/decorators";
import { isReactUINode } from "../../../lib/utils";
import { Menu } from "../../Menu";
import { MenuItem } from "../../../components/MenuItem";
import { Spinner } from "../../../components/Spinner";
import { MenuSeparator } from "../../../components/MenuSeparator";
import { ComboBoxRequestStatus } from "../CustomComboBoxTypes";
import { CustomComboBoxLocaleHelper } from "../locale";
export var ComboBoxMenu = (_dec = locale('ComboBox', CustomComboBoxLocaleHelper), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ComboBoxMenu, _Component);

  function ComboBoxMenu() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.locale = void 0;

    _this.renderItem = function (item, index) {
      // NOTE this is undesireable feature, better
      // to remove it from further versions
      var _this$props = _this.props,
          renderItem = _this$props.renderItem,
          onValueChange = _this$props.onValueChange;

      if (typeof item === 'function' || /*#__PURE__*/React.isValidElement(item)) {
        // @ts-ignore
        var element = typeof item === 'function' ? item() : item;
        var props = Object.assign({
          key: index,
          onClick: function onClick() {
            return onValueChange(element.props);
          }
        }, element.props);
        return /*#__PURE__*/React.cloneElement(element, props);
      }

      return /*#__PURE__*/React.createElement(MenuItem, {
        "data-tid": "ComboBoxMenu__item",
        onClick: function onClick() {
          return onValueChange(item);
        },
        key: index
      }, function (state) {
        return renderItem(item, state);
      });
    };

    return _this;
  }

  var _proto = ComboBoxMenu.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        opened = _this$props2.opened,
        items = _this$props2.items,
        totalCount = _this$props2.totalCount,
        loading = _this$props2.loading,
        refMenu = _this$props2.refMenu,
        _this$props2$renderNo = _this$props2.renderNotFound,
        renderNotFound = _this$props2$renderNo === void 0 ? function () {
      return notFound;
    } : _this$props2$renderNo,
        renderTotalCount = _this$props2.renderTotalCount,
        maxMenuHeight = _this$props2.maxMenuHeight,
        requestStatus = _this$props2.requestStatus;
    var _this$locale = this.locale,
        notFound = _this$locale.notFound,
        errorNetworkButton = _this$locale.errorNetworkButton,
        errorNetworkMessage = _this$locale.errorNetworkMessage;

    if (!opened) {
      return null;
    }

    var renderAddButton = null;

    if (this.props.renderAddButton) {
      renderAddButton = this.props.renderAddButton();
    }

    if (loading && (!items || !items.length)) {
      return /*#__PURE__*/React.createElement(Menu, {
        ref: refMenu
      }, /*#__PURE__*/React.createElement(MenuItem, {
        disabled: true
      }, /*#__PURE__*/React.createElement(Spinner, {
        type: "mini",
        dimmed: true
      })));
    }

    if (items === null && requestStatus === ComboBoxRequestStatus.Failed) {
      return /*#__PURE__*/React.createElement(Menu, {
        ref: refMenu,
        maxHeight: maxMenuHeight
      }, /*#__PURE__*/React.createElement(MenuItem, {
        disabled: true,
        key: "message"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          maxWidth: 300,
          whiteSpace: 'normal'
        }
      }, errorNetworkMessage)), /*#__PURE__*/React.createElement(MenuItem, {
        link: true,
        onClick: this.props.repeatRequest,
        key: "retry"
      }, errorNetworkButton));
    }

    if ((items == null || items.length === 0) && renderNotFound) {
      var notFoundValue = renderNotFound();
      if (renderAddButton) return /*#__PURE__*/React.createElement(Menu, {
        ref: refMenu
      }, renderAddButton);
      if (notFoundValue) return /*#__PURE__*/React.createElement(Menu, {
        ref: refMenu
      }, /*#__PURE__*/React.createElement(MenuItem, {
        "data-tid": "ComboBoxMenu__notFound",
        disabled: true
      }, notFoundValue));
      return null;
    }

    var total = null;
    var renderedItems = items && items.map(this.renderItem);
    var countItems = renderedItems == null ? void 0 : renderedItems.filter(function (item) {
      return isReactUINode('MenuItem', item);
    }).length;

    if (countItems && renderTotalCount && totalCount && countItems < totalCount) {
      total = /*#__PURE__*/React.createElement(MenuItem, {
        disabled: true,
        key: "total"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 12
        }
      }, renderTotalCount(countItems, totalCount)));
    }

    return /*#__PURE__*/React.createElement(Menu, {
      "data-tid": "ComboBoxMenu__items",
      ref: refMenu,
      maxHeight: maxMenuHeight
    }, renderedItems, total, renderAddButton && [/*#__PURE__*/React.createElement(MenuSeparator, {
      key: "separator"
    }), renderAddButton]);
  };

  return ComboBoxMenu;
}(Component), _class2.__KONTUR_REACT_UI__ = 'ComboBoxMenu', _class2.defaultProps = {
  repeatRequest: function repeatRequest() {
    return undefined;
  },
  requestStatus: ComboBoxRequestStatus.Unknown
}, _temp)) || _class);